// All 39 Rhode Island municipalities — 8 cities + 31 towns
// Source: RI Secretary of State municipal listing (official).
// Cities (8): Central Falls · Cranston · East Providence · Newport · Pawtucket · Providence · Warwick · Woonsocket
// Towns (31): Barrington · Bristol · Burrillville · Charlestown · Coventry · Cumberland · East Greenwich ·
//             Exeter · Foster · Glocester · Hopkinton · Jamestown · Johnston · Lincoln · Little Compton ·
//             Middletown · Narragansett · New Shoreham · North Kingstown · North Providence · North Smithfield ·
//             Portsmouth · Richmond · Scituate · Smithfield · South Kingstown · Tiverton · Warren ·
//             West Greenwich · West Warwick · Westerly

export const RI_CITIES = [
  "Barrington",
  "Bristol",
  "Burrillville",
  "Central Falls",
  "Charlestown",
  "Coventry",
  "Cranston",
  "Cumberland",
  "East Greenwich",
  "East Providence",
  "Exeter",
  "Foster",
  "Glocester",
  "Hopkinton",
  "Jamestown",
  "Johnston",
  "Lincoln",
  "Little Compton",
  "Middletown",
  "Narragansett",
  "Newport",
  "New Shoreham",
  "North Kingstown",
  "North Providence",
  "North Smithfield",
  "Pawtucket",
  "Portsmouth",
  "Providence",
  "Richmond",
  "Scituate",
  "Smithfield",
  "South Kingstown",
  "Tiverton",
  "Warren",
  "Warwick",
  "West Greenwich",
  "West Warwick",
  "Westerly",
  "Woonsocket",
];

export const RI_CITY_DEFAULT = "Providence";
